import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';
import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';

import XingLoading from '@xingternal/lazy-loading';

import styles from './styles.css';

import {
  LAZY_LOADING_TYPE_BUTTON,
  LAZY_LOADING_TYPE_SCROLL,
} from '../../constants';

const typesList = [LAZY_LOADING_TYPE_BUTTON, LAZY_LOADING_TYPE_SCROLL, null];

type LazyLoadingProps = {
  type?: typeof typesList[number];
  isLoading?: boolean;
  enabled: boolean;
  onLazyLoad: () => void;
  spinnerSize?: string;
  ctaText?: string;
  dotAnimation?: boolean;
};

const LazyLoading = ({
  type,
  isLoading,
  onLazyLoad,
  enabled = true,
  spinnerSize = '32px',
  ctaText,
  dotAnimation = false,
}: LazyLoadingProps) => {
  if (!enabled) return null;
  return (
    <div className={styles.lazyloadContainer}>
      {type === LAZY_LOADING_TYPE_BUTTON &&
        (isLoading ? (
          <DotLoadingIndicator size={spinnerSize} />
        ) : (
          <Button variant={'secondary'} size={'small'} onClick={onLazyLoad}>
            <FormattedMessage id={ctaText || 'EP_LOAD_MORE_CTA'} />
          </Button>
        ))}
      {type === LAZY_LOADING_TYPE_SCROLL && (
        <XingLoading
          dotAnimation={dotAnimation}
          loading={isLoading}
          onLazyLoad={(unobserve: () => void) => {
            if (enabled) {
              onLazyLoad();
            } else {
              unobserve();
            }
          }}
        />
      )}
    </div>
  );
};

export default LazyLoading;
